import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Button, Input, Textarea } from "expano-components";
import { Dashboard } from "components";
import { updateRemark } from "actions/remarks";
import {
  Field,
  reduxForm,
  SubmissionError,
} from "redux-form";

const TextAreaField = (props) => <Textarea {...props} />;

const reporterLabel = (user) =>
  user ? `${user.first_name} ${user.last_name}` : "-";

const readOnlyInputProps = (name, value) => ({
  input: { name, value, readOnly: true },
  meta: { touched: false, invalid: false, valid: true },
});

const canEditRemark = (current_user, remark) =>
  current_user?.is_admin ||
  (current_user?.can_manage_remarks &&
    remark?.reporter?.id === current_user?.id);

const validate = (values, { current_user, remark }) => {
  if (!canEditRemark(current_user, remark)) {
    return {};
  }

  const errors = {};

  if (!values.content?.trim()) {
    errors.content = "Treść uwagi jest wymagana";
  }

  return errors;
};

const BasicData = ({
  remark,
  current_user,
  updateRemark,
  pristine,
  handleSubmit,
  history,
}) => {
  const can_edit = canEditRemark(current_user, remark);

  const onSubmit = (values) => {
    if (!can_edit) {
      return Promise.resolve();
    }

    return updateRemark(remark.id, { content: values.content })
      .then(() => history.push("/remarks"))
      .catch((err) => {
        throw new SubmissionError(err);
      });
  };

  return (
    <div className="column-half">
      <Dashboard
        header={{
          title: "Dane uwagi",
          icon: "info",
        }}
        footer={{
          buttons: (
            <>
              <Button
                type="cancel"
                onClick={() => history.push("/remarks")}
              />
              {can_edit && (
                <Button
                  key="submit"
                  disabled={pristine}
                  type="save"
                  onClick={handleSubmit(onSubmit)}
                />
              )}
            </>
          ),
        }}>
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <div className="dashboard__form__submit">
            <Input
              label="Osoba zgłaszająca"
              {...readOnlyInputProps(
                "reporter",
                reporterLabel(remark?.reporter)
              )}
            />
            <Input
              label="Osoba, której dotyczy uwaga"
              {...readOnlyInputProps(
                "reported_user",
                reporterLabel(remark?.reported_user)
              )}
            />
            {can_edit ? (
              <Field
                name="content"
                label="Treść uwagi"
                component={TextAreaField}
              />
            ) : (
              <Input
                label="Treść uwagi"
                {...readOnlyInputProps("content", remark?.content)}
              />
            )}
            {remark?.approved_at && (
              <Input
                label="Data zatwierdzenia"
                {...readOnlyInputProps(
                  "approved_at",
                  moment(remark.approved_at).format("DD.MM.YYYY HH:mm")
                )}
              />
            )}
          </div>
        </form>
      </Dashboard>
    </div>
  );
};

const mapStateToProps = ({ remark, current_user }) => ({
  remark: remark?.data,
  current_user,
  initialValues: {
    content: remark?.data?.content,
  },
});

const mapDispatchToProps = (dispatch) => ({
  updateRemark: (id, data) => dispatch(updateRemark(id, data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "edit-remark",
    enableReinitialize: true,
    validate,
  })(BasicData)
);
